module.exports = __webpack_public_path__ + "img/temperature.18337d56.png";